import React, { FunctionComponent, SVGProps } from 'react';

import styled, { css } from 'styled-components';

import { motion } from 'framer-motion';

export interface CircleDownloadIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
  iconSize?: number;
  onClick?: (ev: React.MouseEvent<SVGSVGElement, MouseEvent>) => void;
}

export const CircleDownloadIcon: FunctionComponent<CircleDownloadIconProps> = ({
  className,
  onClick,
}) => {
  const animation = {
    rest: {
      y: 0,
    },
    hover: {
      y: -3,
      transition: {
        ease: [0.0, 0.0, 0.25, 1.0],
        duration: 0.15,
      },
    },
    click: {
      y: 3,
    },
  };

  return (
    <motion.svg
      className={className}
      onClick={(ev) => (onClick ? onClick(ev) : null)}
      viewBox="0 0 50 50"
      initial="rest"
      whileHover="hover"
      whileTap="click"
      animate="rest"
      exit="click"
    >
      <circle cx="25" cy="25" r="25" />
      <motion.path
        variants={animation}
        d="M23.5,17.5v5.1l-.93-.93c-.59-.59-1.54-.58-2.12,0-.3,.3-.44,.68-.44,1.07s.14,.77,.44,1.07l3.51,3.5c.28,.28,.67,.44,1.07,.44s.78-.17,1.07-.45l3.48-3.59c.58-.59,.57-1.54-.03-2.12-.59-.58-1.54-.57-2.12,.03l-.91,.96v-5.08c0-.84-.67-1.5-1.5-1.5s-1.5,.67-1.5,1.5h-.01Z"
      />
      <path d="M33.51,33.51c.3-.3,.49-.71,.49-1.17v-4.15c0-.91-.75-1.66-1.66-1.66s-1.66,.75-1.66,1.66v2.49h-11.38v-2.49c0-.91-.75-1.66-1.66-1.66s-1.65,.76-1.65,1.67v4.14c0,.91,.75,1.66,1.66,1.66h14.68c.46,0,.87-.18,1.17-.49Z" />
    </motion.svg>
  );
};

export default styled(CircleDownloadIcon)`
  width: ${(props) => (props.iconSize ? props.iconSize : '50')}px;
  height: ${(props) => (props.iconSize ? props.iconSize : '50')}px;

  ${(props) =>
    props.onClick
      ? css`
          cursor: pointer;
          circle {
            transition: fill
              ${({ theme }) =>
                `${theme.transitions.duration} ${theme.transitions.type}`};
          }
          &:hover {
            circle {
              fill: ${({ theme }) => theme.colors.secondaryHover};
            }
          }
        `
      : null}

  circle {
    fill: ${({ theme }) => theme.colors.secondary};
  }

  path {
    fill: ${({ theme }) => theme.colors.primary};
  }
`;
